import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {communityGuidelines} from '#/lib/policies'
import {PolicyDocument} from '#/components/PolicyDocument'

type Props = NativeStackScreenProps<
  CommonNavigatorParams,
  'CommunityGuidelines'
>
export const CommunityGuidelinesScreen = (_props: Props) => {
  return <PolicyDocument {...communityGuidelines} />
}
